export default __webpack_public_path__ + "static/media/consulting-green.a6b13872.svg";